import { render, staticRenderFns } from "./Treasuries.vue?vue&type=template&id=c82a98f2&"
import script from "./Treasuries.vue?vue&type=script&lang=js&"
export * from "./Treasuries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports